import { Form, Formik } from "formik";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import "../../PhanHeKhamBenh.scss";
import PhieuKhamBenh from "../../components/tab-kham-benh/PhieuKhamBenh";
import { createThongTinKhamBenh, updateThongTinKhamBenh } from "../../services/PrintExportService";
import { useContext } from "react";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import { CODE } from "../../../utils/Constant";
import { toast } from "react-toastify";
import { removeEventEnter } from "../../../utils/AppFunction";

export type KhamBenh = {
  thongTinKhamBenh?: any;
  setThongTinKhamBenh: ((data: any) => void) | undefined;
};

export const TabKhamBenh = () => {
  const { benhNhanInfo, setBenhNhanInfo, statusChangedEventFunc } = useContext(PhanHeTiepDonContext);
  const intl = useIntl();
  const validationSchema = Yup.object({
    encounterDiagnosis: Yup.object().shape({
      reasonForEncounter: Yup.string().required(intl.formatMessage({ id: "VALIDATION.REQUIRE" })),
      // diagnosisNonCoded: Yup.string().when('provisionalDiagnosis', (value, schema) => {
      //   if (value !== undefined && !value) {
      //     return schema.required(intl.formatMessage({ id: "VALIDATION.REQUIRE" }));
      //   }
      //   return schema; // đảm bảo trả về schema nếu điều kiện không khớp
      // }).nullable(),
    }),
  });

  const initialValues = {};

  const handleSubmit = async (values: any) => {
    let encounterDiagnosisValues = values?.encounterDiagnosis;
    let obsValues = values?.obs;
    let patientObsForms = values?.patientObsForms;
    const { patient, visit, encounter, orderId } = benhNhanInfo?.thongTinKhamBenh;
    
    if (!encounterDiagnosisValues?.diagnosisNonCoded && !encounterDiagnosisValues?.provisionalDiagnosis) {
      toast.warning("Vui lòng nhập thông tin chẩn đoán!");
      return;
    }

    const submitData = {
      patientId: patient?.id,
      visitId: visit?.id,
      orderId: orderId,
      encounterDiagnosis: {
        reasonForEncounter: encounterDiagnosisValues?.reasonForEncounter,
        pathologicalProcess: encounterDiagnosisValues?.pathologicalProcess,
        medicalHistoryPast: encounterDiagnosisValues?.medicalHistoryPast,
        medicalHistoryFamily: encounterDiagnosisValues?.medicalHistoryFamily,
        physicalExamOfBody: encounterDiagnosisValues?.physicalExamOfBody,
        physicalExamGeneral: encounterDiagnosisValues?.physicalExamGeneral,
        provisionalDiagnosis: encounterDiagnosisValues?.provisionalDiagnosis,
        paraclinicalSummary: encounterDiagnosisValues?.paraclinicalSummary,
        comorbidity: encounterDiagnosisValues?.comorbidity,
        currentMedications: encounterDiagnosisValues?.currentMedications,
        diagnosisNonCoded: encounterDiagnosisValues?.diagnosisNonCoded,
        diagnosisConclusion: encounterDiagnosisValues?.diagnosisConclusion,
      },
      obs: {
        personId: patient?.personId,
        orderId: orderId,
        values: {
          pr: obsValues?.pr,
          bt: obsValues?.bt,
          spo2: obsValues?.spo2,
          rr: obsValues?.rr,
          bpSys: obsValues?.bpSys,
          bpDia: obsValues?.bpDia,
          weight: obsValues?.weight,
          height: obsValues?.height,
          bmi: obsValues?.bmi,
          creatinine: obsValues?.creatinine,
          crcl: obsValues?.crcl,
          egfr: obsValues?.egfr,
        }
      },
      patientObsForms
    };
    
    try {
      let { data } = encounter
        ? await updateThongTinKhamBenh({
          ...submitData,
          encounterDiagnosis: {
            ...encounterDiagnosisValues,
            ...submitData?.encounterDiagnosis,
          },
          obs: {
            ...submitData?.obs,
            encounterId: encounterDiagnosisValues?.encounterId,
          }
        })
        : await createThongTinKhamBenh(submitData);
      if (CODE.SUCCESS === data?.code) {
        let encounterDiagnosis = data?.data?.encounterDiagnosis;
        let encounter = data?.data?.encounter;
        let obs = data?.data?.obs;
        setBenhNhanInfo({
          ...benhNhanInfo,
          isExamined: true,
          thongTinKhamBenh: {
            ...benhNhanInfo?.thongTinKhamBenh,
            ...(encounter && { encounter }),
            ...(obs && { obs }),
            ...(encounterDiagnosis && { encounterDiagnosis }),
          },
          shouldUpdate: !benhNhanInfo?.shouldUpdate,
        });
        toast.success("Cập nhật thành công");
      } else {
        toast.warning(data?.message || "Xảy ra lỗi, vui lòng thử lại!");
        statusChangedEventFunc?.()
      }
    } catch (error) {
      console.error(error);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");

    }
  };

  return (
    <Formik<any>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <Form className="pe-2 tab-kham-benh bg-white">
        <PhieuKhamBenh />
      </Form>
    </Formik>
  );
};

export default TabKhamBenh;
